/* eslint-disable react/display-name */
/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { getPath, setSubscriptionRedirect } from '../../../utils';
import { defaultTheme, defaultDarkTheme } from '../../../constants';

import './introduction-card.m.css';

export const PageIntroduction = Component => props => {
  const { pageType = '', config = {} } = useSelector(state => get(state, ['qt'], {}));
  const sketchesHost = get(config, ['sketches-host'], '');
  const whiteListedUrlParams = get(config, ['pagebuilder-config', 'general', 'others', 'whiteListedUrlParams'], []);
  const supportedPages = {
    'tag-page': 'tag',
    'author-page': 'author',
    'authors-page': 'authors',
    'magazine-landing-page': 'magazine-landing',
    'magazine-archive-page': 'archive',
    'section-page': 'section',
    'collection-page': 'section',
    'pagebuilder-section-preview-page': 'section',
    'pagebuilder-collection-preview-page': 'section',
    'collection-page-preview': 'section',
    '': ''
  };
  const magazinePage = pageType === 'magazine-landing-page' || pageType === 'magazine-archive-page';
  let updatedPathRowConfig;

  if (magazinePage) {
    updatedPathRowConfig = ['magazine', supportedPages[pageType], 'rows', 0, 'config'];
  } else if (pageType === 'authors-page') {
    updatedPathRowConfig = [supportedPages[pageType], 'rows', 0, 'config'];
  } else {
    updatedPathRowConfig = [supportedPages[pageType], 'config'];
  }
  const updatedPathPageSetting = !magazinePage ? [supportedPages[pageType]] : ['magazine', supportedPages[pageType]];
  const enableDarkMode = useSelector(state => get(state, ['header', 'isDarkModeEnabled'], false));
  const rowConfig = get(config, ['pagebuilder-config', ...updatedPathRowConfig], {});
  const { pageSetting = {} } = get(config, ['pagebuilder-config', ...updatedPathPageSetting], {});
  let theme = get(rowConfig, ['theme'], get(pageSetting, ['bgColor'], defaultTheme));
  if (enableDarkMode) {
    theme = get(rowConfig, ['darkTheme'], get(pageSetting, ['darkBgColor'], defaultDarkTheme));
  }

  const { config: authorsPageConfig = {}, layout = '' } = get(props, ['collection', 'associated-metadata'], {});
  let updatedConfig = {
    ...authorsPageConfig,
    theme
  };
  if (pageType === 'author-page') {
    const { enableLocalization, localizedElements } = get(
      config,
      ['pagebuilder-config', 'general', 'localization'],
      {}
    );
    updatedConfig = {
      customConnect: enableLocalization ? get(localizedElements, ['buttonLabels', 'connect']) : 'Connect',
      theme
    };
  }

  const customUrlPath = updatedConfig?.customUrlPath || '';
  if (magazinePage && customUrlPath && customUrlPath.includes('subscription')) {
    updatedConfig.pageType = 'magazine';
    updatedConfig.onSubscriptionClick = () =>
      setSubscriptionRedirect(
        getPath({
          sketchesHost,
          relativePath: `/${customUrlPath}`,
          injectCustomParams: true,
          whiteListedUrlParams
        }),
        sketchesHost,
        whiteListedUrlParams
      );
  }
  const data = get(props, ['collection', 'props'], {});
  return (
    <div
      className='component-wrapper'
      styleName='intro-card'
      style={layout === 'ArrowPageIntroductionCard' ? { overflow: 'unset' } : {}}
    >
      <Component data={data} config={updatedConfig} />
    </div>
  );
};
